export default "__VITE_ASSET__Dqz4TgSi__"